<div class="p-4">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

  <div class="card">
    <p-table
      #dt
      [value]="activityType"
      [rows]="10"
      [paginator]="true"
      [totalRecords]="totalRecords"
      [loading]="isLoading"
      [lazy]="true"
      (onLazyLoad)="loadActivityTypes($event)"
      dataKey="id"
      styleClass="p-datatable-striped"
    >
       <ng-template pTemplate="caption">
        <div class="flex w-full items-center">
          <h2 class="m-0">Activity Types</h2>

          <div class="ml-auto">
            <p-button
              label="New Activity Type"
              icon="pi pi-plus"
              (onClick)="createActivityType()"
            ></p-button>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">Activity Type Name <p-sortIcon field="name"></p-sortIcon></th>
          <th pSortableColumn="code">Activity Type Code <p-sortIcon field="code"></p-sortIcon></th>
          <th>AR Account</th>
          <th>AP Account</th>
          <th>Reference</th>
          <th style="width:10rem">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-activityType>
        
        <tr>
          <td>{{ activityType.name }}</td>
          <td>{{ activityType.code ?? null }}</td>
          <td>{{ activityType.arAccount ?? null }}</td>
          <td>{{ activityType.apAccount ?? null }}</td>
          <td>{{ activityType.reference ?? null }}</td>
          <td>
            <div class="flex gap-2">
              <p-button icon="pi pi-pencil" styleClass="p-button-rounded p-button-success" (onClick)="editActivityType(activityType.id)"></p-button>
              <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-danger" (onClick)="deleteActivityType(activityType)"></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="4">No Activity Types found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>